var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "row no-margin CustomPageTabContainer" }, [
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "tab tab1" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("Default Tab")]),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    [
                      _c("b-tab", { attrs: { title: "Tab 1", active: "" } }, [
                        _c("br"),
                        _vm._v(
                          "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Tab 2" } }, [
                        _c("br"),
                        _vm._v(
                          "Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Tab 3" } }, [
                        _c("br"),
                        _vm._v(
                          "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.\n                            "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "tab tab2" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("Default Tab")]),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    [
                      _c("b-tab", { attrs: { title: "Tab 1", active: "" } }, [
                        _c("br"),
                        _vm._v(
                          "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Tab 2" } }, [
                        _c("br"),
                        _vm._v(
                          "Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Tab 3" } }, [
                        _c("br"),
                        _vm._v(
                          "Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.\n                            "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "height15" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "tab tab4" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Custom Vertical Tab")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { pills: "", card: "", vertical: "" } },
                        [
                          _c(
                            "b-tab",
                            { attrs: { title: "Dashboard", active: "" } },
                            [
                              _c("h3", { staticClass: "tabtitle-heading" }, [
                                _vm._v("Best Clean Tab ever")
                              ]),
                              _vm._v(" "),
                              _c("h4", { staticClass: "title-label" }, [
                                _vm._v("you can use it with the small code")
                              ]),
                              _vm._v(
                                "\n\n                                    Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-tab", { attrs: { title: "Profile" } }, [
                            _vm._v(
                              "\n                                    Tab Contents 2\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-tab", { attrs: { title: "Mails" } }, [
                            _vm._v(
                              "\n                                    Tab Contents 3\n                                "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "height15" }, [_vm._v(" ")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 paddingleft0" }, [
              _c(
                "div",
                { staticClass: "tab tab5" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("Default Tab")]),
                  _vm._v(" "),
                  _c(
                    "b-tabs",
                    [
                      _c(
                        "b-tab",
                        { attrs: { title: "Yesterday", active: "" } },
                        [
                          _c("h3", { staticClass: "tabtitle-heading" }, [
                            _vm._v("Best Clean Tab ever")
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(
                            "Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-tab", { attrs: { title: "Tomorrow" } }, [
                        _c("h3", [_vm._v("Best Clean Tab ever")]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.\n                            "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Tabs")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c58ee6e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c58ee6e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs.vue
// module id = null
// module chunks = 